import { gql, useQuery } from "@apollo/client";
import {SELECT_OPTION_FIELDS, SelectOptionType } from "graphql/types/SelectOptionType";

export const GET_ALL_SETTLEMENT_TRACKING_POINTS = gql`
    query GetAllSettlementTrackingPoints {
        getAllSettlementTrackingPoints {
            code
            name
            description
        }
    }
`;

export const LIST_SETTLEMENT_TRACKING_POINTS = gql`
    query SettlementClientQuery {
        allOptions: listSettlementTrackingPointOptions {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface SettlementTrackingPointEnumType {
    code: string;
    name: string;
    description: string;
}

interface ListSettlementTrackingPointOptionsResponse {
        allOptions: SelectOptionType[];
}

export const useAllSettlementTrackingPoints = () => {
    const { data, loading, error } = useQuery<ListSettlementTrackingPointOptionsResponse>(
        LIST_SETTLEMENT_TRACKING_POINTS,
        {
            fetchPolicy: 'cache-and-network'
        }
    );

    return {
        settlementTrackingPoints: data?.allOptions || [],
        loading,
        error
    };
};

